import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import './SignageMediaLibrary.css';
import API from "../../../utils/API";

const EditFiles = ({
  selectedFiles,
  setSelectedFiles,
  setSuccess,
  closeModal,
  loadTable,
  fetchFolderTreeData,
  dataMap
}) => {

  const [mediaName, setMediaName] = useState('');
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  /**
    * Reset modal
    */
  function resetModal() {
    setSubmitted(false);
    setModalError('');
    setMediaName('');
    setSelectedFiles(null);
  }

  useEffect(() => {
    const modalElement = document.getElementById('editFilesModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);
  
  useEffect(() => {
    setMediaName(selectedFiles?.name || '');
  }, [selectedFiles]);

  /**
   * Handle form input change
   */
  const handleChange = useCallback((e) => {
    const value = e.target.value;
    setMediaName(value);
    if (value.length < 2 || value.length > 36) {
      setModalError(<FormattedMessage id="MEDIA_NAME_LENGTH" />);
    } else {
      setModalError('');
    }
  }, []);

  /**
   * Add new group to the database
   */
  const handleAddNewFolder = async () => {
    const name = mediaName.trim();
    if (name.length < 2 || name.length > 36) {
      setModalError(<FormattedMessage id="MEDIA_NAME_LENGTH" />);
      return;
    }
    try {
      const mediaData = {
        data:{
          /*category: constants.SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA,
          subcategory: constants.SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.FILE,
          type: constants.SIGNAGE_MEDIA.MEDIA_SUB_CATEGORY.FILE,
          parentId: null,*/
          name,
        }
      };
      const res = await API.updateMediaFile(selectedFiles?.id, mediaData);
      if(res.status === 200){
        setSuccess(<FormattedMessage id="EDIT_FOLDER_SUCCESS" />);
        if (typeof fetchFolderTreeData === 'function') fetchFolderTreeData();
        if (typeof loadTable === 'function') loadTable(dataMap);
      }else{
        setModalError(<FormattedMessage id="EDIT_FOLDER_FAILED" values={{ errorMsg: '' }} />);
      }
      closeModal("editFilesModal");
      resetModal();
    } catch (err) {
      const errorMessage = err.message;
      setModalError(<FormattedMessage id="EDIT_FOLDER_FAILED" values={{ errorMsg: <b>{errorMessage}</b> }} />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (mediaName) {
      handleAddNewFolder();
    } else {
      setModalError(<FormattedMessage id="SUBMIT_ERROR" />);
    }
  };

  return (
    <div className='modal modal-mse fade' id='editFilesModal' tabIndex='-1' aria-labelledby='editFilesModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='EDIT_MEDIA' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body'>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='mediaNameSection mb-2'>
                  <label htmlFor='mediaNameLabel' className='font-weight-600 font-size-14 mb-2'>
                    <FormattedMessage id={'MEDIA_NAME'} />:
                  </label>
                  <input
                    id="mediaNameInput"
                    onChange={handleChange}
                    value={mediaName}
                    name='mediaName'
                    placeholder={t('MEDIA_NAME')}
                    className={`form-control h-54 bg-baby-blue ${submitted && (modalError ? 'is-invalid' : 'is-valid')}`}
                  />
                </div>
                {submitted && modalError && (
                  <div className='modal-error invalid-feedback d-block fw-bold text-center'>
                    {modalError}
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='CONTINUE' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFiles;
